/** Remove only illegal spacer BRs immediately between list boundaries/items.
 * Text, list items, nested content and BRs inside an LI are left intact.
 * Runs identically in SSR and the browser without a DOM/parser dependency.
 */
export function normalizeListSpacers(html: string) {
  return html
    .replace(/(<(?:ul|ol)\b[^>]*>)\s*(?:<br\s*\/?>\s*)+/gi, '$1')
    .replace(/(<\/li>)\s*(?:<br\s*\/?>\s*)+(?=<li\b|<\/(?:ul|ol)>)/gi, '$1');
}
